module.exports = __webpack_public_path__ + "assets/c016b60e59523a2d40996e3a01dc7b5a.mp4";